import { Button } from './Button/Button';
import { Modal } from './Modal/Modal';
import styles from './ConfirmModal.module.css';

interface Props {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm(): void;
  onClose(): void;
}

export function ConfirmModal({
  title,
  message,
  confirmLabel = 'Slet',
  cancelLabel = 'Annullér',
  danger = false,
  onConfirm,
  onClose,
}: Props) {
  return (
    <Modal
      title={title}
      onClose={onClose}
      actions={
        <>
          <Button variant="secondary" onClick={onClose}>
            {cancelLabel}
          </Button>
          <Button
            variant="primary"
            className={danger ? styles.dangerBtn : undefined}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className={styles.message}>{message}</div>
    </Modal>
  );
}
